goog.provide('el8.appanalytics.util');

goog.require('el8.uiwidget.collapsible');

el8.appanalytics.util = (function() {

    return {
        
        initCollapsibleFilters: function(container) {
            el8.uiwidget.collapsible({
                container: $('.collapsible-filter-section', container),
                triggerElt: $('.expand-collapse-trigger', container),
                statusElt: $('.expand-collapse-trigger', container),
                statusTextCollapse: "Show Report Filters",
                statusTextExpand: "Hide Report Filters",
                expandFn: function() {
                    $('.report-contents', container).addClass('el8ReportFilterOpen');
                },
                collapseFn: function() {
                    $('.report-contents', container).removeClass('el8ReportFilterOpen');
                },
                isCollapsed: false
            });
        }
    
    };

})();


